export const ACCOUNT_MANAGEMENT = "account/management"